import * as React from "react";
import { AColumn, AsyncTable } from "src/components/tables/AsyncTable";
import { TableStore } from "src/components/tables/TableStore";
import { observer } from "mobx-react-lite";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { ZMc2 } from "../../Mc2Types";

interface PropsMc2PointsSelect {
  store: TableStore<ZMc2, {}>;
}

export const Mc2PointsSelect: React.FC<PropsMc2PointsSelect> = observer(
  ({ store }) => (
    <AsyncTable
      store={store}
      columns={columns}
      onRowClick={(row) => selectOnRowClick(row, store)}
    />
  ),
);

const columns: AColumn<ZMc2>[] = [
  {
    key: "name",
    title: "Название MC",
    width: "20%",
    render: (_, row) => row.name,
  },
  {
    key: "sizeLine",
    title: "Размерный ряд",
    width: "10%",
    render: (_, row) => row.sizeLineName,
  },
  {
    key: "baseSize",
    title: "Базовый размер",
    width: "15%",
    render: (_, row) => row.baseSize,
  },
  {
    key: "comment",
    title: "Комментарий",
    render: (_, row) => row.comment,
  },
];
